module.exports = __webpack_public_path__ + "img/logo_yc_white.00054488.png";